<template>
  <div class="m-wap-original" v-if="readOrigin == 1 && linkUrl != ''">
    <a :href="linkUrl" target="_self">阅读原文</a>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Return",
  data() {
    return {
      readOrigin: 0,
      linkUrl: ""
    };
  },
  methods: {},
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.readOrigin = info.readOrigin;
        this.linkUrl = info.linkUrl;
      }
    });
  }
};
</script>
